<div class="u-flex-full">
  <label>{{value?.identifier}} <span *ngIf="value?.id">-</span> {{value?.description}} <span *ngIf="value?.closed" class="closed"> {{'projects.Closed' | translate}}</span></label>
  <button class="close" *ngIf="value?.id && !disabled" mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
    (click)="clearProject()">
    <mat-icon>close</mat-icon>
  </button>
</div>
